/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "前往App Store下载",
      "结识​附近的​群组",
      "在Hive中，​遇见​新朋友。",
      "寻找与你​志趣​相投​的人",
      "无论你的​兴趣​是什么，​你都会​找到​一个​适合​你的​Hive！",
      "放心做自己",
      "选择私人Hive​或​公开Hive。",
      "新手上路",
      "无论你热爱什么，​都能​找到​适合你​的​Hive",
      "在Bumble BFF中，​结识​新的​朋友圈",
      "您被邀请​加入Hive",
      "通过Bumble BFF的​新功能​Hive​结识​当地的​群组。​立即​在Bumble​应用​软件中​创建​BFF​个人​档案。",
      "前往Google Play下载",
      "管理Cookies",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小时"
            ],
            "singular": [
                  "小时"
            ]
      },
      "minute": {
            "plural": [
                  "分钟"
            ],
            "singular": [
                  "分钟"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
